import styles from "./Header.module.css";
import { ReactComponent as KlashaPinkLogo } from "../../../assets/klasha-icon.svg";
import { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { RoutingContext } from "../../../context/Router";
import Loader from "../Loader";

type State = {
    data: any;
    loading: boolean;
    error: Error | null;
};

export const Header = ({ email }: { email: string }) => {
    const { payData } =
        useContext(RoutingContext);
    const { businessId } = payData.kit
    const [state, setState] = useState<State>({
        data: null,
        loading: true,
        error: null
    });
    const fetchData = useCallback(async () => {
        setState(prevState => ({ ...prevState, loading: true }));
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}merchant/customization/${businessId}?type=EMAIL`, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                        "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                    })
                }
            });

            setState(prevState => ({
                ...prevState,
                data: response.data?.data?.businessLogo,
                loading: false,
                error: null
            }));
        } catch (error) {
            setState(prevState => ({
                ...prevState,
                error: error instanceof Error ? error : new Error('An unknown error occurred'),
                loading: false,
                data: prevState.data?.data
            }));
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    return (
        <>
        <Loader isLoading={state.loading} />
        <div className={styles.container}>
            {state.loading ? <p>loading...</p> : (
                <div>
                {state.data !== undefined ? <img src={state.data} className={styles.logo} alt="merchant-logo" />
                    : (
                        <KlashaPinkLogo />
    
                    )}
                </div>
            )}
            <p>{email}</p>
        </div>
        </>
    );
};


